import { BaseCssVarValue } from '@/views/game/components/gameCardSuit/components/baseCssVarInject'

export abstract class _TriangleHeartBase extends BaseCssVarValue {
  abstract cssType: 'default'
  /** 收藏图标尺寸(宽高) */
  ['--favorited-icon-side']?: string
}
